import {Box} from '@primer/react'
import {CommandKeybindingHint} from '@github-ui/ui-commands'

export function ControlsDialogHint() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        right: 'var(--space-large)',
        transform: 'translateY(-66%)',
        bg: 'canvas.default',
        color: 'fg.muted',
        boxShadow: 'shadow.medium',
        border: '1px solid',
        borderColor: 'border.default',
        p: 1,
        pl: 2,
        borderRadius: 2,
        display: 'none',
        gap: 3,
      }}
      className="controls-dialog-hint"
    >
      <span>Manage this item</span>{' '}
      <CommandKeybindingHint commandId="list-views:open-manage-item-dialog" format="condensed" />
    </Box>
  )
}

try{ ControlsDialogHint.displayName ||= 'ControlsDialogHint' } catch {}